import { AccountAvailableCash } from '../type';

export const cCurrencyCodeKeyFn = (v: AccountAvailableCash) => v['C_CURRENCY.CODE'];
